import * as helper from "../../helpers/disposition";

import { DISPOSITION_STATUS } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { updateDispositionSuccess } from "../../api/disposition_End_call";

export const initialState = {
  Dispositionstatus: "",
  summary: "",
  isOpenDisPositionStatus: false,
  dispositionTime: "00:60",
  callWrapupTime: 59,
  completeDisposition: {},
  errorStatus: "",
  cycle: 0,
  started: false,
  storeInterval: "",
  subject: "",
  errorSubject: "",
  errorSummary: "",
  isChatDisPositionStatus: false,
  dispositionId: 0,
  isCurrentDispostionEnd: false,
  sessionId: 0
};

const dispositionSlice = createSlice({
  name: DISPOSITION_STATUS,
  initialState,
  reducers: {
    setDispositionOpen: (state, { payload }) => {
      state.isOpenDisPositionStatus = payload.isOpenDisPositionStatus
      state.errorStatus = "";
    },
    setChatDispositionOpen: (state, { payload }) => {
      state.isChatDisPositionStatus = payload.isChatDisPositionStatus
      state.errorStatus = "";
    },
    backToDisposition: (state, { payload }) => {
      state.dispositionTime = payload.dispositionTime;
      state.callWrapupTime = payload.callWrapupTime;
    },
    startDispositionTimer: (state) => {
      helper.dispositionTimer(state);
    },
    setDisposition: (state, { payload }) => {
      if (payload) {
        state.Dispositionstatus = payload?.key?.dispositionName;
        state.completeDisposition = payload?.key;
        state.errorStatus = "";
      }
    },
    setDispositionId: (state, { payload }) => {
      state.dispositionId = payload;
    },
    storeIntervalData: (state, { payload }) => {
      state.storeInterval = payload;
    },
    setSummary: (state, { payload }) => {
      state.summary = payload;
      state.errorSummary = "";
    },
    setSubject: (state, { payload }) => {
      state.subject = payload;
      state.errorSubject = "";
    },
    setError: (state, { payload }) => {
      state.errorStatus = payload;
    },
    setErrorSubject: (state, { payload }) => {
      state.errorSubject = payload;
    },
    setErrorSummary: (state, { payload }) => {
      state.errorSummary = payload;
    },
    isCurrentDispostionEnd: (state, { payload }) => {
      // console.log("isCurrentDispostionEnd",payload)
      state.isCurrentDispostionEnd = payload;
    },
    setDispositionSessionId: (state, { payload }) => {
      state.sessionId = payload;
    },
    reset: () => { },
  },

  // extraReducers: (builder) => {

  //   builder.addCase(updateDispositionSuccess.fulfilled, (state, { payload }) => {
  //     if (payload?.data?.statusCode === 200) {

  //     } else {

  //     }

  //   });

  // },
});

export const dispositionSliceActions = dispositionSlice.actions;
export default dispositionSlice.reducer;
